<template>
  <div
    v-if="currentUser && currentAccounts && currentAccount"
    id="dashboard">
    <NavBar/>
    <LoadingBar/>
    <Notify/>
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
    <Footer/>
  </div>
  <div v-else>
    <LoadingBar
      :force-on="!loadFailed"
      :force-top="true"/>
    <table class="oto-app-loading-screen">
      <tr>
        <td>
          <img src="../../assets/cp-logo.png">
          <p v-if="!loadFailed">{{ loadingPhrase }}</p>
          <div v-else>
            <p>We could not load your account. Your login is still valid.</p>
            <button
              class="button is-primary is-rounded"
              type="button"
              @click="retryLoad">
              Try again
            </button>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import NavBar from '@/components/elements/NavBar'
import LoadingBar from '@/components/elements/LoadingBar'
import Notify from '@/components/elements/Notify'
import Footer from '@/components/dashboard/Footer'
import { mapGetters } from 'vuex'

export default {
  components: {
    NavBar,
    LoadingBar,
    Notify,
    Footer
  },
  computed: {
    loadingPhrase: function () {
      return this.loadingPhrases[Math.floor(Math.random() * this.loadingPhrases.length)]
    },
    ...mapGetters({
      fatal: 'fatal',
      currentUser: 'currentUser',
      currentAccounts: 'currentAccounts',
      currentAccount: 'currentAccount',
      currentAccountChannels: 'currentAccountChannels'
    })
  },
  data () {
    return {
      loadFailed: false,
      loadingTimer: null,
      loadingTimeout: 30000, // time we wait for a proper account and business before showing retry
      loadingPhrases: [
        'The Captain has turned off the Fasten Seat Belt sign.',
        'Make sure your seat backs and tray tables are in their full upright position.',
        'Flight attendants please prepare for gate departure.',
        'Cabin crew please take your seats for take-off.',
        'Sit back, relax, and enjoy the rest of the flight.',
        'Flight attendants prepare doors for departure.',
        'Please remain seated until the Captain turns off the Fasten Seat Belt sign.',
        'Buckle up and get ready for takeoff!',
        'Welcome aboard! We\'re ready to soar to new heights.',
        'Cabin crew, prepare for landing.',
        'Flying high above the clouds.',
        'Pilot here, get ready for a smooth ride.',
        'We hope you have enjoyed your flight with us.',
        'Clear skies and tailwinds ahead.',
        'Up, up, and away we go!'
      ]
    }
  },
  watch: {
    fatal: function (val) {
      if (val && !this.currentUser && !this.currentAccount) {
        this.loadFailed = true
        this.clearLoadingTimer()
      }
    }
  },
  mounted () {
    this.$store.dispatch('setFatal', false)
    this.retryLoad()
    // this is used when embedding in CampaignPilot into another system (i.e. Tee Sheet)
    if (this.$route.query.embedmode) {
      var jwt = null
      if (this.$route.query.token) {
        var base64Url = this.$route.query.token.split('.')[1]
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        }).join(''))
        jwt = JSON.parse(jsonPayload)
      }
      if (jwt) {
        // valid embedmode, save it to the global store
        this.$store.dispatch('setEmbedMode', {
          mode: this.$route.query.embedmode,
          token: this.$route.query.token,
          jwt: jwt
        })
      }
    }
  },
  beforeDestroy () {
    this.clearLoadingTimer()
  },
  methods: {
    startLoadingTimer () {
      var vm = this
      this.clearLoadingTimer()
      this.loadingTimer = setTimeout(function () {
        if (!vm.currentUser || !vm.currentAccounts || !vm.currentAccount || !vm.currentAccountChannels) {
          vm.loadFailed = true
        }
      }, vm.loadingTimeout)
    },
    clearLoadingTimer () {
      if (this.loadingTimer) {
        clearTimeout(this.loadingTimer)
        this.loadingTimer = null
      }
    },
    retryLoad () {
      this.loadFailed = false
      this.$store.dispatch('setFatal', false)
      this.$store.dispatch('fetchUser')
      this.$store.dispatch('fetchAccounts')
      this.startLoadingTimer()
    }
  }
}
</script>
